import {
  Component,
  inject,
} from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { EmployeeEditService } from "./employee-edit.service";
import { HostListener } from "@angular/core";
import { Router, RouterOutlet } from "@angular/router";
import { HeaderComponent } from "../header/header.component";

@Component({
  selector: "app-archive-view",
  imports: [
    ReactiveFormsModule,
    RouterOutlet,
    HeaderComponent,
  ],
  providers: [EmployeeEditService],
  templateUrl: "./archive-view.component.html",
  styleUrls: ["./archive-view.component.css"],
})
export class ArchiveViewComponent {
  swSauver = false;

  @HostListener("window:beforeunload", ["$event"])
  unloadNotification($event: BeforeUnloadEvent): void {
    if (!this.swSauver) {
      $event.preventDefault();
      $event.returnValue = "";
    }
  }

  canDeactivate(): boolean {
    if (!this.swSauver) {
      return confirm(
        "Vous avez des modifications non sauvegardées. Quitter la page ?",
      );
    }

    return true;
  }

  readonly router = inject(Router);

  /*
  public ngOnInit(): void {
    this.rootData = this.editService;
    this.editService.read(); // Lecture telerik

    const state = undefined; // localStorage.getItem("treeState");

    if (state) {
      const treeState = JSON.parse(state);
      this.data = treeState.data;
      this.expandedIds = treeState.expandedIds;
    }
  }*/
}
